import React from 'react'
import { Box, Typography } from '@mui/material'
import { List, DatagridConfigurable, TextField, DateField, FunctionField, ListBase, Link, useGetIdentity } from 'react-admin'
import Empty from '../../common/Empty'
import { ENV_BASED_CONSTANTS } from '../../../utils/constants'

const OrderDataGrid = () => {
  return (
    <DatagridConfigurable
      bulkActionButtons={false}
      sx={{
        '& .RaDatagrid-headerCell': {
          fontSize: 12,
          fontWeight: 500,
          color: 'var(--text-secondary)',
          textTransform: 'none',
          borderBottom: '0.5px solid var(--border)',
        },
        '& .RaDatagrid-rowCell': {
          padding: '16px',
          borderRight: 'none',
        },
        '& .RaDatagrid-row': {
          borderBottom: '0.5px solid var(--border)',
        },
        '& .RaDatagrid-row:last-of-type': {
          borderBottom: 'none',
        },
        '& .RaDatagrid-row:hover': {
          backgroundColor: 'var(--fill-ghost-hover)',
        },
      }}
    >
      <TextField source="shopifyOrderNumber" label="Order #" />
      <FunctionField
        label="SKUs"
        render={(record) => {
          const lineItems = record.shopifyData?.line_items || []
          return lineItems.map((item) => item.sku).join(', ')
        }}
      />
      <DateField
        source="shopifyData.created_at"
        label="Order Date"
        options={{ year: 'numeric', month: '2-digit', day: '2-digit' }}
        showTime={false}
      />
      <FunctionField
        label="Show"
        render={(record) => (
          <Link
            to={`/provider-portal/bulk-orders/${record.orderId}`}
            style={{ color: 'var(--text-accent)', textDecoration: 'none' }}
          >
            <span className="fa-solid fa-eye" aria-hidden="true"></span> SHOW
          </Link>
        )}
      />
    </DatagridConfigurable>
  )
}

const BulkOrders = () => {
  const { identity } = useGetIdentity()
  const loggedInUserEmail = identity?.email || localStorage.getItem('provider_portal_customer_email') || 'current account'

  return (
    <ListBase resource="provider-portal/bulk-orders" sort={{ field: 'shopifyData.created_at', order: 'DESC' }} perPage={100}>
      <List
        resource="provider-portal/bulk-orders"
        actions={false}
        empty={<Empty text="No bulk orders found." />}
        pagination={false}
        title="Bulk Orders"
        sx={{
          '& .RaList-content': {
            background: 'var(--surface-2)',
            border: '0.5px solid var(--border)',
            borderRadius: '12px',
            boxShadow: 'none',
            overflow: 'hidden',
          },
        }}
      >
        <Box sx={{ p: 3, pb: 1 }}>
          <Typography variant="h4" gutterBottom>
            Bulk Orders
          </Typography>
          <Typography paragraph>
            View test results of kits your office has distributed directly to patients. This list shows orders for bulk kits placed with your account (
            <Box
              component="span"
              sx={{
                backgroundColor: 'action.selected',
                px: 0.75,
                py: 0.25,
                borderRadius: 0.75,
                fontWeight: 600,
              }}
            >
              {loggedInUserEmail}
            </Box>
            ) from{' '}
            <Box component="a" href={ENV_BASED_CONSTANTS.storeURL} target="_blank" rel="noopener noreferrer" sx={{ color: 'inherit' }}>
              {ENV_BASED_CONSTANTS.storeURLLabel}
            </Box>
            .
          </Typography>
        </Box>
        <OrderDataGrid />
      </List>
    </ListBase>
  )
}

export default BulkOrders
